/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Room } from '../../models/room';

export interface GetRoom$Params {
  roomId: string;
}

export function getRoom(http: HttpClient, rootUrl: string, params: GetRoom$Params, context?: HttpContext): Observable<StrictHttpResponse<Room>> {
  const rb = new RequestBuilder(rootUrl, getRoom.PATH, 'get');
  if (params) {
    rb.path('roomId', params.roomId, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Room>;
    })
  );
}

getRoom.PATH = '/chat/v0/rooms/{roomId}';
